import { useEffect, useState } from "react";
import PropertyForm from "./PropertieForm";
import PropertyTable from "./PropertyTable";
import { deleteProperty, getProperties } from "@/api/propierties";

export default function PropertiesAdmin() {

  const [properties, setProperties] = useState([]);
  const [editingProperty, setEditingProperty] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const load = async () => {
    const res = await getProperties();
    setProperties(res);
  };

  useEffect(() => {
    load();
  }, []);

  const remove = async (id) => {
    if (!window.confirm("¿Eliminar propiedad?")) return;
    await deleteProperty(id);
    load();
  };

  const edit = (property) => {
    setEditingProperty(property);
    setShowForm(true);
  };

  const newProperty = () => {
    setEditingProperty(null);
    setShowForm(true);
  };

  const saved = () => {
    setEditingProperty(null);
    setShowForm(false);
    load();
  };

  return (
    <div className="max-w-7xl mx-auto p-6 space-y-6">

      <div className="flex justify-between items-center">

        <h1 className="text-3xl font-bold">
          Administración de Propiedades
        </h1>

        <button
          onClick={newProperty}
          className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg"
        >
          ➕ Nueva Propiedad
        </button>

      </div>

      {/* FORMULARIO */}

      {showForm && (
        <div className="bg-gray-50 p-6 rounded-lg border">

          <PropertyForm
            property={editingProperty}
            onCreated={saved}
          />

          <button
            onClick={() => setShowForm(false)}
            className="mt-4 bg-gray-500 text-white px-4 py-2 rounded"
          >
            Cancelar
          </button>

        </div>
      )}

      {/* TABLA */}

      <PropertyTable
        properties={properties}
        onEdit={edit}
        onDelete={remove}
      />

    </div>
  );
}